import * as React from 'react';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import { useTagOnKeyDown } from '../../hooks';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Tag = function Tag(props) {
  var children = props.children,
    onClose = props.onClose,
    size = props.size;
  var deviceType = useDeviceType();
  var onKeyDown = useTagOnKeyDown(onClose);
  var styles = getStyles(size ? size : deviceType === 'phone' ? 'M' : 'XS');
  return /*#__PURE__*/_jsxs("div", {
    className: styles['tag'],
    tabIndex: 0,
    onKeyDown: onKeyDown,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['tag_content'],
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles['tag_close'],
      onClick: onClose,
      children: /*#__PURE__*/_jsx(IconActionClose12, {
        color: "icon-secondary-default"
      })
    })]
  });
};
Tag.displayName = 'Tag';